import '.c7{position:relative;}.ssr-plugin'
import '.av{position:absolute;}.ssr-plugin'
import '.ex{font-size:0.75rem;}.ssr-plugin'
import '.ey{line-height:normal;}.ssr-plugin'
import '.ez{top:-0.25rem;}.ssr-plugin'
import '.f0{right:-0.5rem;}.ssr-plugin'
import '.f1{background-color:var(--gray-100);}.ssr-plugin'
import '.f2{border-radius:0.35rem;}.ssr-plugin'
import '.f3{width:0.75rem;}.ssr-plugin'
import '.f4{height:0.75rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  faPaperclip,
  type IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRef, ChangeEvent } from 'react'

export type FileSelectorProps = {
  icon?: IconDefinition
  filesSelected?: number
  maxFiles?: number
  maxSizeMB?: number
  allowedFileTypes?: string[]
  iconStyle?: Style
  containerStyle?: Style
  onFileSelectionUpdated: (files: File[]) => void
  disabled?: boolean
}

export const FileSelector = ({
  icon,
  filesSelected = 0,
  maxFiles = 1,
  maxSizeMB = 5,
  allowedFileTypes = ['image/jpeg', 'image/png'],
  iconStyle,
  containerStyle,
  onFileSelectionUpdated,
  disabled = false,
}: FileSelectorProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const onFileUploadClicked = () => {
    if (!disabled) {
      fileInputRef.current?.click()
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files: File[] = []
    const maxSizeBytes = maxSizeMB * 1024 * 1024
    for (const file of event.target.files) {
      if (files.length === maxFiles) {
        break
      }
      if (!allowedFileTypes.includes(file.type)) {
        continue
      }
      if (file.size > maxSizeBytes) {
        continue
      }
      files.push(file)
    }
    onFileSelectionUpdated(files)
  }

  return (
    <>
      <styled.div className="c7"
        onClick={onFileUploadClicked}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          ...containerStyle,
        }}
      >
        <FontAwesomeIcon icon={icon ?? faPaperclip} style={iconStyle} />
        {filesSelected > 0 && (
          <span className="av ex ey ez f0 f1 f2 f3 f4 a f b"
          >
            {filesSelected}
          </span>
        )}
      </styled.div>

      <input
        type="file"
        multiple={maxFiles > 1}
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={disabled}
        style={{ display: 'none' }}
      />
    </>
  )
}
